import * as requests from 'api/requests';
import { 
    addingContributor,
    addingContributorSuccess,
    addingContributorFailure,
    updatingContributor,
    updatingContributorSuccess,
    updatingContributorFailure,
    gettingContributorsByDashboard,
    gettingContributorsByDashboardSuccess,
    gettingContributorsByDashboardFailure,
    deletingContributor,
    deletingContributorSuccess,
    deletingContributorFailure
} from 'redux/actions/contributor';
import { displayErrorSwal } from 'utilities/Validations';

export function addContributor(newContributor) {
    return (dispatch) => {
        dispatch(addingContributor());

        return requests
            .addContributor(newContributor)
            .then((data) => {
                dispatch(addingContributorSuccess(newContributor));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred adding this contributor, please try again later.')
                dispatch(addingContributorFailure(error));
            });
    };
}

export function getContributorsByDashboard(siteId, dashboardId) {
    return (dispatch) => {
        dispatch(gettingContributorsByDashboard());

        return requests
            .getContributorsByDashboard(siteId, dashboardId)
            .then((data) => {
                dispatch(gettingContributorsByDashboardSuccess(data));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred getting this contributors for this dashboard, please try again later.');
                dispatch(gettingContributorsByDashboardFailure(error));
            });
    };
}

export function updateContributor(contributor) {
    return (dispatch) => {
        dispatch(updatingContributor());

        return requests
            .updateContributor(contributor)
            .then((data) => {
                dispatch(updatingContributorSuccess(contributor));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred updating this contributor, please try again later.');
                dispatch(updatingContributorFailure(error));
            });
    };
}

export function deleteContributor(contributor) {
    return (dispatch) => {
        dispatch(deletingContributor());

        return requests
            .deleteContributor(contributor)
            .then((data) => {
                dispatch(deletingContributorSuccess(contributor));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred updating this contributor, please try again later.');
                dispatch(deletingContributorFailure(error));
            });
    };
}